import React from 'react';
import '../Styles/styles.css';

const FinancialAccounting = () => {
    return (
        <section id="financial-accounting" className="">
            <div className="container">
                <div className="section-title">
                    <h2 >Financial Accounting</h2>
                </div>
                <div className='text-center'>
                    <p className='textr-muted'>Cloud Accounting</p>
                </div>
                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <h4 className="card-title">Client</h4>
                        <p>One of Bangalore's oldest and biggest jewelers.</p>
                    </div>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <h4 className="card-title">Requirement</h4>
                        <p>Development of a comprehensive online financial management system working as a backend to a large point of sales Jewellery manufacturing and trading organization.</p>
                    </div>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <h4 className="card-title">Solution</h4>
                        <p>MMCS was responsible for the design, development, and implementation of the solution. The design team interacted with end users to understand and document the business process and workflow.</p>
                        <p>The solution involved the development of a software system that ran on Microsoft Windows 2000 Clients and interacted with an Oracle database hosted on a Sun Solaris machine. The solution also interfaced with a large front office management solution that managed case sales and order processing.</p>
                        <h5>Developed Modules:</h5>
                        <ul>
                            <li>General and sub ledgers</li>
                            <li>Cash receipt and payments</li>
                            <li>Expense tracking - with emphasis on advertising budget</li>
                            <li>Bills control</li>
                            <li>Fixed assets accounting</li>
                            <li>Balance sheet and Profit & Loss account</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FinancialAccounting;
